export const PLACES_SET = 'setPlaces';
export const PLACES_SELECTED = 'setSelected';
export const PLACES_LOADING = 'setLoading';
export const PLACES_ERROR = 'setError';
